import script from "./TransferHistoryTab.vue?vue&type=script&setup=true&lang=js"
export * from "./TransferHistoryTab.vue?vue&type=script&setup=true&lang=js"

import "./TransferHistoryTab.vue?vue&type=style&index=0&id=d6619576&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6619576"]])

export default __exports__